const { title } = require('gulp-svg-symbols/lib/default-config');
const {
	trackGtm,
	trackGtm4,
	setClass,
	fillWithDomElements,
	fillWithDomElementsAll,
	injectFocusablesList,
} = require('util/functions');
const { stuttering, default: onWidthResize } = require('util/onWidthResize');

const CLASS_ACTIVE = 'active';
const CLASS_CONTAINER = 'event-highlight-partial--container';
const CLASS_CONTENT = 'event-highlight-partial--content';
const CLASS_LINK = 'event-highlight-partial--link';
const CLASS_TABS = 'event-highlight-partial--tab-link';
const CLASS_CALENDAR_BUTTON = 'event-highlight-partial--calendar-button';
const CLASS_CALENDAR_MENU = 'calendar-menu--menu';
const CLASS_CALENDAR_ITEM = 'calendar-menu--item';

const SELECTOR_CALENDAR_CONTAINER = '.event-highlight-partial--calendars';
const SELECTOR_DESCRIPTION = '.event-highlight-partial--description';

const elementClassesAll = {
	tabs: CLASS_TABS,
	contents: CLASS_CONTENT,
	links: CLASS_LINK,
	calendarMenuItems: CLASS_CALENDAR_ITEM,
};
const elementClasses = {
	container: CLASS_CONTAINER,
};

module.exports = {
	init() {
		fillWithDomElementsAll(this, elementClassesAll);
		fillWithDomElements(this, elementClasses);
		this.contents.forEach(content => {
			injectFocusablesList(content);
			content.addEventListener('click', e => {
				const currentTile =
					e.target.tagName == 'A'
						? e.target
						: e.target.closest('.event-highlight-partial--content');
				const tileTitle = currentTile.querySelector(
					'.event-highlight-partial--title',
				).innerHTML;
				const arrowLabel = currentTile.querySelector('.arrowed-link').innerHTML;
				this.gtm4Tracking(tileTitle, arrowLabel, currentTile.href);
			});
		});
		this.links.forEach(link => {
			link.addEventListener('click', e => {
				const currentTile = this.root.querySelector(
					'.event-highlight-partial--content.active',
				);
				const tileTitle = currentTile.querySelector(
					'.event-highlight-partial--title',
				).innerHTML;
				this.gtm4Tracking(tileTitle, e.target.innerHTML, e.target.href);
			});
		});
		this.current = 0;
		this.adaptHeight();
		this.initCalendars();
		this.initEvents();
	},
	initCalendars() {
		const calendars = this.root.querySelectorAll('.' + CLASS_CALENDAR_MENU);
		this.calendars = {};
		calendars.forEach(calendar => {
			this.calendars[calendar.dataset.number] = calendar;
		});
	},
	initEvents() {
		this.tabs.forEach((tab, number) => {
			tab.addEventListener('click', () => {
				const widgetName = this.root.getAttribute('data-parent');
				this.tabClick(number);
				trackGtm4({
					event: 'GA4_event_c_content_navigation_click',
					widget_name: widgetName,
					widget_title: 'No title',
					widget_type: 'article',
					link_text: tab ? tab.innerHTML.trim() : 'No text: tab nav',
					link_url: tab.href ? tab.href : 'No url',
					interaction_type: `tab ${tab.innerHTML.trim()}`,
				});
			});
		});
		this.contents.forEach((content, i) => {
			const calendarButton = content.querySelector('.' + CLASS_CALENDAR_BUTTON);
			if (calendarButton)
				calendarButton.addEventListener('click', e => {
					e.preventDefault();
					this.openCalendar(i);
				});
		});
		// Calendar is going to be there, but it is safe to check
		if (this.calendarMenuItems) {
			this.gtmTracking();
		}
		// Window events
		onWidthResize(this.adaptHeight.bind(this), stuttering.DEBOUNCE, 100);
	},
	openCalendar(selectedCalendar) {
		Object.keys(this.calendars).forEach(key => {
			const calendar = this.calendars[key];
			setClass(calendar, selectedCalendar == key, CLASS_ACTIVE);
		});
		setTimeout(() => {
			document.addEventListener('click', this.closeCalendars.bind(this), {
				once: true,
			});
		}, 0);
	},
	tabClick(number) {
		this.current = number;
		this.contents.forEach((content, i) => {
			const link = this.links[i];
			const tab = this.tabs[i];
			const active = i === number;
			setClass(content, active, CLASS_ACTIVE);
			setClass(link, active, CLASS_ACTIVE);
			[...content.__focusables, link].forEach(focusable =>
				focusable.setAttribute('tabindex', active ? 0 : -1),
			);
			tab.disabled = active;
		});
		this.adaptHeight();
		this.closeCalendars();
	},
	gtmTracking() {
		Array.from(this.calendarMenuItems).forEach(menuItem =>
			menuItem.addEventListener('click', () => {
				const action = menuItem.textContent;
				// To reach active content's description under general container
				const calendarContainer = menuItem.closest(SELECTOR_CALENDAR_CONTAINER);
				const container = calendarContainer.nextElementSibling;
				const activeContent = container.querySelector(
					`.${CLASS_CONTENT}.${CLASS_ACTIVE}`,
				);
				const description =
					activeContent.querySelector(SELECTOR_DESCRIPTION).textContent;
				trackGtm({
					eventCategory: 'add to calendar',
					eventAction: action,
					eventLabel: description,
				});
			}),
		);
	},
	gtm4Tracking(widgetTitle, linkText, linkUrl) {
		const widgetName = this.root.getAttribute('data-parent');
		trackGtm4({
			event: 'GA4_event_c_cta',
			widget_name: widgetName,
			widget_title: widgetTitle,
			link_text: linkText,
			link_url: linkUrl,
			button_type: '',
		});
	},
	adaptHeight() {
		const content = this.contents[this.current];
		const height = content.offsetHeight;
		this.container.style.height = `${height}px`;
	},
	closeCalendars() {
		Object.keys(this.calendars).forEach(calendar =>
			setClass(this.calendars[calendar], false, CLASS_ACTIVE),
		);
	},
};
